import { RefObject, useCallback, useRef } from 'react'

import { useInterval } from 'commons/hooks/common'
import { localStorageService } from 'commons/service/localStorageService'

import { RemainingTimeRecord, getRemainTime } from './getRemainTime'

export const useGetSessionExpiresAt = ({
  hasUser
}: {
  hasUser: boolean
}): RefObject<RemainingTimeRecord | undefined> => {
  const expiresIn = useRef<RemainingTimeRecord | undefined>()

  const checkSessionExpiration = useCallback(() => {
    if (!hasUser && !expiresIn) {
      return
    }

    expiresIn.current = hasUser ? getRemainTime(localStorageService.getSessionExpiresAt()) : undefined
  }, [expiresIn, hasUser])

  useInterval(checkSessionExpiration)

  return expiresIn
}
